var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"browser"}},[_c('v-container',[_c('file-browser',{attrs:{"axiosConfig":{ baseURL: '/' },"user":_vm.$store.state.user}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }